import listening from "./../assets/images/listening.svg";
import moozik from "./../assets/images/moozik.svg";
import musicFilterBlueTint from "./../assets/images/musicFilterBlueTint.png";
import screenshotMultipleFilterBlueTint from "./../assets/images/screenshotMultipleFilterBlueTint.png";
import phone from "./../assets/images/phone.svg";
import playstore from "./../assets/images/playStorev2.svg";
import appstore from "./../assets/images/appStorev2.svg";
import musicFilterBlueTintLarge from "./../assets/images/musicFilterBlueTintLargeYAS.png";

import Header from "../components/Header";
import Offer from "./../components/Offer";

const offerList = [
  {
    offername: "MOOZIK 1 Jour",
    rpid: "B280",
    validity: "1 JOUR",
    amount: "500",
    nbtitle: "70Mo",
    data: "30Mo",
    hourlisten: "100Mo",
  },
  {
    offername: "MOOZIK 7 Jours",
    rpid: "B281",
    validity: "7 JOURS",
    amount: "3000",
    nbtitle: "400Mo",
    data: "250Mo",
    hourlisten: "650Mo",
  },
  {
    offername: "MOOZIK 30 Jours",
    rpid: "B282",
    validity: "30 JOURS",
    amount: "10000",
    nbtitle: "1.5Go",
    data: "1 Go",
    hourlisten: "2.5Go",
  },
];

const Home = () => {
  const navigateToPlayStore = () => {
    const url =
      "https://play.google.com/store/apps/details?id=com.moozik.android";
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const navigateToAppStore = () => {
    const url =
      "https://apps.apple.com/mg/app/moozik-musique-et-karaok%C3%A9/id6503946864?l=fr-FR";
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="bg-whitesmoke-300 min-h-screen flex justify-center">
      <div className="max-w-[641px] w-full bg-[#130B2B] h-auto overflow-hidden text-left text-base text-white font-montserrat">
        <Header hideMsisdn />
        <div className="relative top-[5px] left-[0px] w-[100%] h-[fit-content] max-h-full z-5">
          <img
            className="relative top-[-40px] w-[100%] object-contain"
            alt=""
            src={listening}
          />
          <div className="absolute bottom-[-15%] left-[5%] w-[100%]">
            <img
              className="relative w-[102px] h-[102px] object-cover"
              alt=""
              src={moozik}
            />
            <div className="relative mt-7 text-10xl leading-[42px] uppercase font-black text-whitesmoke-200 z-10">
              <p className="m-0 z-10 sm:text-16xl xs:text-10xl">{`Streaming de `}</p>
              <p className="m-0 z-10 sm:text-16xl xs:text-10xl">{`musique et `}</p>
              <p className="m-0 z-10 sm:text-16xl xs:text-10xl">{`vidéo `}</p>
            </div>
            <div className="relative top-[-5%] right-[5%] [background:#001038] z-5">
              <img
                className="relative top-[-70px] w-[100%] object-cover"
                alt=""
                src={musicFilterBlueTint}
              />
              <div className="absolute z-2 bottom-[0px] left-[0px] w-[100%] h-[100%] flex items-center flex-col justify-center">
                <b className="relative top-[-25%] left-[0px] text-[25px] uppercase text-center">
                  OFFRE DATA MOOZIK TELMA
                </b>
                <div className="relative top-[30px] left-[0px] text-sm leading-[21px]">
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="relative top-[-25px] h-auto">
          <img
            className="relative top-[0px] w-[100%] h-[1600px] object-fill"
            alt=""
            src={screenshotMultipleFilterBlueTint}
          />
          <div className="absolute top-[0px] w-[100%] h-auto">
            <div className="absolute top-[0px] [background:linear-gradient(0deg,_rgba(1,_16,_56,_0)_30.00%,_#001038_90.00%)] w-[100%] h-[700px]"></div>
            <div className="relative w-[100%] h-[1000px] max-h-[1000px] overflow-auto top-[-45px]">
              <div key={"offerList"}>
                {offerList.map((elt, i) => (
                  <Offer key={i} id={i} {...elt} />
                ))}
              </div>
            </div>
            <div className="absolute w-[100%] h-auto">
              <div className="relative w-[100%]">
                <div className="relative z-10 left-[5%] text-5xl leading-[38px] uppercase font-extrabold mt-12">
                  <p className="m-0">Télécharger</p>
                  <p className="m-0">l'application</p>
                  <p className="m-0">maintenant</p>
                </div>
                <div className="relative z-10 left-[5%] text-smi leading-[21px] mt-6">
                  {/* <p className="m-0">Lorem ipsum dolor sit amet, consectetur</p>
                  <p className="m-0">adipiscing elit</p> */}
                </div>
                <div className="relative w-[100%] mt-8">
                  <div className="absolute bottom-[0px] [background:linear-gradient(180deg,_rgba(1,_16,_56,_0)_30.00%,_#123274_100.00%)] w-[100%] h-[700px]"></div>
                  <div className="absolute z-9 top-[0px] [background:linear-gradient(0deg,_#123274_30.00%,_#123274_140.00%)] w-[100%] h-[750px]"></div>
                </div>
                <div className="relative mt-8 left-[0%] flex items-center justify-evenly">
                  <img
                    className="w-[145px] h-[45px] object-cover rounded z-20 cursor-pointer"
                    alt=""
                    src={playstore}
                    onClick={() => navigateToPlayStore()}
                  />
                  <img
                    className="w-[145px] h-[45px] object-cover rounded z-20 cursor-pointer"
                    alt=""
                    src={appstore}
                    onClick={() => navigateToAppStore()}
                  />
                </div>
                <div className="relative mt-4 w-[100%]">
                  <img
                    className="absolute top-[0px] w-[100%] z-10 object-cover"
                    alt=""
                    src={phone}
                  />
                  <img
                    className="absolute top-[10px] z-8 w-[100%] object-cover"
                    alt=""
                    src={musicFilterBlueTintLarge}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
